import React from "react";

const NotFound = () => {
  return <div className="not-found">page not found!</div>;
};

export default NotFound;
